import vue from 'vue';
import moment from 'moment';

vue.filter('moment', (value, arg) => moment(value).format(arg));



// WEBPACK FOOTER //
// ./src/filters/format.filter.js